import React, { ReactElement, useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import {
  Col, Heading, Row, Table, Tbody, Td, Th, Thead, Tr,
} from 'idsk-react-components';
import './pouzivatelskePrirucky.scss';
import Prirucka from '../../model/Prirucka';
import DownloadButton from './component/DownloadButton';
import PouzivatelskePriruckyMobileTableItem from './component/PouzivatelskePriruckyMobileTableItem';
import { useSecurityContext } from '../../context/SecurityContext';

interface Props {
  data: Prirucka[] | null | undefined;
}

const PouzivatelskePrirucky = ({ data }: Props): ReactElement => {
  const { userRoles } = useSecurityContext();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = (): void => {
      setIsMobile(window.innerWidth < 640);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const userIsLogged = (): boolean => userRoles?.length === 1 && userRoles[0] === 'null';

  const userHaveRole = (roles: Array<string>): boolean => !!userRoles?.some(
    userRole => roles.includes(userRole),
  );

  const shouldSekciaBeVisible = (roles: Array<string>):boolean => {
    if (userRoles === undefined) {
      return false;
    }
    if (roles === null || roles === undefined || roles.length === 0) {
      return true;
    }
    if (!userIsLogged() && roles.includes('loggedUser')) {
      return true;
    }
    return userHaveRole(roles);
  };

  const visibleData = data?.filter(sekcia => shouldSekciaBeVisible(sekcia.roles));

  return (
    <div className="prirucky">
      <Heading size="xl" className="prirucky-main__heading">
        Používateľské príručky
      </Heading>
      {visibleData?.map((sekcia) => (
        <Row className="prirucky-main__row" key={sekcia.id}>
          <Col className="prirucky-main__col" width="two-thirds">
            <>
              {/* eslint-disable-next-line react/no-danger */}
              <h3 className="sekcia-heading" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sekcia.nazov) }} />
              {/* eslint-disable-next-line react/no-danger */}
              <div className="prirucky-popis" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sekcia.popis) }} />
              {sekcia.riadky && (
                isMobile ? (
                  <>
                    {sekcia.riadky.map((riadok) => (
                      <PouzivatelskePriruckyMobileTableItem
                        key={`priruckyRiadokMobileKey-${riadok.id}`}
                        actions={(
                          <DownloadButton
                            url={process.env.REACT_APP_MAGNOLIA_API_BASE_PATH + riadok.hodnotaStlpecTreti}
                          />
                        )}
                        nazovRiadokPrvy={sekcia.nazovStlpecPrvy}
                        nazovRiadokDruhy={sekcia.nazovStlpecDruhy}
                        hodnotaRiadokPrvy={riadok.hodnotaStlpecPrvy}
                        hodnotaRiadokDruhy={riadok.hodnotaStlpecDruhy}
                      />
                    ))}
                  </>
                ) : (
                  <Table className="prirucky-main__table">
                    <Thead>
                      <Tr>
                        <Th scope="row">{sekcia.nazovStlpecPrvy}</Th>
                        <Th scope="row">{sekcia.nazovStlpecDruhy}</Th>
                        <Th scope="row">{sekcia.nazovStlpecTreti}</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {sekcia.riadky.map((riadok) => (
                        <Tr key={`priruckyRiadokKey-${riadok.id}`}>
                          <Td>{riadok.hodnotaStlpecPrvy}</Td>
                          <Td>{riadok.hodnotaStlpecDruhy}</Td>
                          <Td>
                            <DownloadButton
                              url={process.env.REACT_APP_MAGNOLIA_API_BASE_PATH + riadok.hodnotaStlpecTreti}
                            />
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                )
              )}
            </>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default PouzivatelskePrirucky;
